import React from 'react'
import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useEffect } from 'react'
import { ADMIN_API, USER_API } from '../../../functions'
import axios from 'axios'
import { Navbar, AllTestCards } from '../../../Components'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import lottie from 'lottie-web'
import { useRef } from 'react'




const AllTests = () => {

    const [tests, setTests] = useState([]);
    const [testsinfo, setTestsInfo] = useState([])
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);


    const AddNewTestBtn = () => {
        return (
            <Link
                to="/Admin/test"
                className="bg-blue-500 flex hover:bg-blue-700 gap-3 text-white font-bold p-3 rounded mt-12 fixed sm:right-5 sm:bottom-5 right-1 bottom-2"
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className='hidden sm:inline-block'>Add New Test</span>
            </Link>
        )
    }
    const ref = useRef(null);

    const Loader = () => {
        useEffect(() => {
            const Animator = lottie.loadAnimation({
                container: ref.current,
                animationData: require('../../../Components/Animations/LoadingBarsRotation.json'),
                renderer: 'svg',
                loop: true,
                autoplay: true,

            });
            return () => Animator.destroy();
        }, [])
        return (
            <div className='flex flex-col justify-center items-center h-screen'>
                <div className='w-1/2' ref={ref} ></div>
                Loading
            </div>
        )
    }


    const ContentLoader = async () => {
        try {
            const res = await axios.get(`${ADMIN_API}/getAllTest`)
            const data = res.data.foundTests
            setTests(data)
            setTestsInfo(data)
        } catch (error) {
            Swal.fire(
                'Error!',
                'Could not load tests.',
                'error'
            )
        }
        finally {
            setLoading(false)
        }
    }

    const formatName = (name) => {
        let temp = name.split('_')[1]
        return temp
    }

    const handleEditTest = (e, test) => {
        e.preventDefault();
        navigate(`/Admin/editTest/${test._id}`)

    }

    const handleDeleteTest = async (e, test) => {
        e.preventDefault();
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteTest(test);

            }
        })

    }

    const deleteTest = async (test) => {
        try {
            const res = await axios.post(`${ADMIN_API}/deleteTest`, { testId: test._id })
            Swal.fire(
                'Deleted!',
                'Test has been deleted.',
                'success'
            ).then(() => {
                window.location.reload();
            })
        } catch (error) {
            console.log(error)
            Swal.fire(
                'Error!',
                'Test could not be deleted.',
                'error'
            )
        }
    }


    const AllTestList = () => {

        if (tests.length === 0) {
            return (
                <>
                    {loading ? <Loader /> : (
                        <div className='flex flex-wrap p-2 justify-center align-middle'>
                            <h1 className='text-center text-2xl'>No Tests Found</h1>
                        </div >
                    )}
                </>
            )
        }

        const formatTime = (time) => {
            let temp = time.split('T')[0]
            temp += ' at ' + time.split('T')[1].split('.')[0]
            return temp
        }

        return (
            <>
                {loading ? <Loader /> : (
                    <div className='flex flex-wrap p-2 justify-center align-middle'>

                        {testsinfo.map((test) => (
                            <>
                                <AllTestCards
                                    name={formatName(test.TestInfo.TestNumber)}
                                    duration={test.TestInfo.TestDuration}
                                    test={test}
                                    type={test.TestInfo.TestType}
                                    classs={test.TestInfo.TestClass}
                                    callbackEdit={handleEditTest}
                                    callbackDelete={handleDeleteTest}
                                    scheduledOn={test.TestInfo.TestDate !== "" ? formatTime(test.TestInfo.TestDate) : null}
                                    resultOn={test.TestInfo.TestDelay !== "" ? formatTime(test.TestInfo.TestDelay) : null}
                                />
                            </>
                        ))
                        }
                    </div >
                )}
            </>
        );

    }

    const checkUser = async () => {
        const user = Cookies.get('user');
        if (user) {
            try {
                let res = await axios.get(`${USER_API}/getData/${user}`);
                if (res.status === 200) {
                    if (!res.data.ifAdmin) {
                        navigate('/login');
                    }
                    else {
                        ContentLoader();
                    }
                }
                else {
                    Cookies.remove('user');
                    navigate('/login');
                }
            }
            catch (error) {
                navigate('/login');
            }
        }
        else {
            navigate('/login');
        }
    }

    useEffect(() => {
        checkUser();
    }, [])

    return (
        <div>
            <Navbar />
            <h1 className='text-center text-2xl'>All Tests</h1>
            <AllTestList />
            <AddNewTestBtn />
        </div>
    )
}

export default AllTests
